module.exports = __webpack_public_path__ + "static/media/notification_board.03a2422c.svg";